const defaultState = {
  appointments: [],
  fetchingAppointments: false,
  appointmentsFetched: false,
  errorAppointments: '',

  appointment: null,
  fetchingAppointment: false,
  fetchedAppointment: false,
  errorAppointment: ''
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "FETCH_APPOINTMENTS": {
        return {
          ...state,
          fetchingAppointments: true,
          appointmentsFetched: false
        }
      }
      case "FETCH_APPOINTMENTS_REJECTED": {
        return {
          ...state,
          errorAppointments: action.payload,
          fetchingAppointments: false,
          appointmentsFetched: false
        }
      }
      case "FETCH_APPOINTMENTS_FULFILLED": {
        return {
          ...state,
          appointments: action.payload,
          fetchingAppointments: false,
          appointmentsFetched: true
        }
      }

      case "FETCH_APPOINTMENT": {
        return {
          ...state,
          fetchedAppointment: false,
          fetchingAppointment: true,
          error: false
        }
      }
      case "FETCH_APPOINTMENT_COMPLETE": {
        return {
          ...state,
          fetchedAppointment: true,
          fetchingAppointment: false,
          appointment: action.payload
        }
      }
      case "FETCH_APPOINTMENT_REJECTED": {
        return {
          ...state,
          fetchedAppointment: false,
          fetchingAppointment: false,
          errorAppointment: action.payload
        }
      }

      case "DELETE_APPOINTMENT_FULFILLED": {
        return {
          ...state,
          appointments: state.appointments.filter((a) => a.id !== action.payload)
        }
      }

      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/appointmentReducer.js